import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'components/Link';
import classNames from 'classnames';
import { bindGa } from 'helpers/analytics';
import {
  debounce,
  isTouch,
  getClassesFromArray,
  // isPrimeUser,
} from 'utils/common';
import { getGeoCountry, getSeoName } from 'utils/primeUtil';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Image from 'components/Image';
import {
  WEB_INDIA_HP_GA_CAT,
  CORONAVIRUS_GA_CATEGORY,
  EXPLAINERS_GA_CATEGORY,
  TIMES_SPECIAL_NOC_NAME,
  TOI_EPAPER_URL_WEB,
} from 'constants/index';
import Cookie from 'utils/cookies';
import NavDropDown from './NavDropDown';
import NavDropDownList from './NavDropDownList';
import Search from '../Search';
import s from './Navigation.scss';

class Navigation extends React.Component {
  static gaCategory = 'nav_menu';
  constructor(props) {
    super(props);
    this.state = {
      l1Sections:
        props.navigationData && props.navigationData.l1
          ? props.navigationData.l1
          : null,
      l2Sections:
        props.navigationData && props.navigationData.l2
          ? props.navigationData.l2
          : null,
      l1cyclicSections: [],
      l2cyclicSections: [],
      showHamburg: false,
      isClientSide: false,
      isSearchOpen: false,
    };

    this.l1Items = [];
    this.l2Items = [];
    this.geoBasedAssistSet = false;
    this.onWindowResize = debounce(this.onWindowResize.bind(this), 300);
    this.callWindowResize = true;
    // this.isPrimeUser = false;
  }

  isGeoInfoPresent = () => {
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      typeof window.geoinfo.CountryCode === 'string'
    ) {
      return window.geoinfo.CountryCode.toLowerCase();
    }
    return false;
  };

  checkIsComponentMounted = () => {
    let geo = this.isGeoInfoPresent();
    if (geo) {
      document.body.classList.add(`geo-${geo}`);
      this.onWindowResize();
    } else {
      /* @todo - need to be done on redux */
      this.timer = setInterval(() => {
        geo = this.isGeoInfoPresent();
        if (geo) {
          document.body.classList.add(`geo-${geo}`);
          this.onWindowResize();
          clearInterval(this.timer);
        }
      }, 1000);
      // clear interval after 5sec if not executed.
      setTimeout(() => {
        clearInterval(this.timer);
      }, 5000);
    }
  };

  handleDocumentClickEvent = event => {
    if (isTouch()) {
      const clickedElement = event.target;
      let clickedElementDrowdown;
      let clickedElementWithSubmenu;
      let elementVisible;
      if (clickedElement.parentNode) {
        clickedElementDrowdown = clickedElement.parentNode.querySelector(
          `.${s.dropdown}`,
        );

        clickedElementWithSubmenu = clickedElement.parentNode.querySelector(
          '.submenu-dropdown',
        );
      }
      if (clickedElementDrowdown) {
        const opacity = window
          .getComputedStyle(clickedElementDrowdown)
          .getPropertyValue('opacity');
        elementVisible = !!parseInt(opacity, 10);
        if (
          !!clickedElement.closest('nav') &&
          clickedElement.parentNode.querySelector(`.${s.dropdown_arrow}`) &&
          !elementVisible
        ) {
          event.preventDefault();
          return false;
        }
      } else if (clickedElementWithSubmenu) {
        const opacity = window
          .getComputedStyle(clickedElementWithSubmenu)
          .getPropertyValue('opacity');
        elementVisible = !!parseInt(opacity, 10);
        if (!!clickedElementWithSubmenu.closest('nav') && !elementVisible) {
          event.preventDefault();
          return false;
        }
      }
    }
    return true;
  };
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClickEvent);
    window.removeEventListener(
      'GUTTER_AD_TYPE_HANDLING',
      this.gutterAdTypeHandling,
    );
    window.removeEventListener(
      'GUTTER_CLOSE_AD_TYPE_HANDLING',
      this.gutterAdTypeHandling,
    );
  }

  gutterAdTypeHandling = () => {
    //In case of gutter ads, triggering the resize event
    setTimeout(this.onWindowResize, 2000);
  };

  componentDidMount() {
    const { pageType } = this.props;
    // this.isPrimeUser = isPrimeUser();
    Navigation.gaCategory =
      pageType && pageType === 'Home'
        ? WEB_INDIA_HP_GA_CAT
        : Navigation.gaCategory;
    this.setCyclicItems();
    document.addEventListener('click', this.handleDocumentClickEvent);
    if (window) {
      window.addEventListener('resize', this.onWindowResize);
      window.addEventListener(
        'GUTTER_AD_TYPE_HANDLING',
        this.gutterAdTypeHandling,
      );
      window.addEventListener(
        'GUTTER_CLOSE_AD_TYPE_HANDLING',
        this.gutterAdTypeHandling,
      );
    }

    this.checkIsComponentMounted();
    // window.top.adsCallback = adtype => {
    //   if (adtype === 'gutter') {
    //     this.gutterAdTypeHandling();
    //   }
    // };

    if (typeof window !== 'undefined') {
      this.setState({ isClientSide: true });
    }
  }

  isUserLoggedin = () => {
    const { userData } = this.props;
    let isLoggedin = false;
    if (userData && userData.isLoggedIn) {
      isLoggedin = true;
    }
    return isLoggedin;
  };

  componentDidUpdate(prevProps) {
    // if timestamp is updated then ???
    // this is causing infinite setstate
    // this.setStateWithProps(this.props);
    if (this.callWindowResize) {
      this.onWindowResize();
      this.callWindowResize = false;
    }
    const { toiAssistNavEnabled, isPrime } = this.props;
    if (
      !this.geoBasedAssistSet &&
      toiAssistNavEnabled &&
      toiAssistNavEnabled === '1' &&
      !isPrime &&
      !(
        prevProps.userData &&
        typeof prevProps.userData === 'object' &&
        'isLoggedIn' in prevProps.userData
      ) &&
      this.props.userData &&
      typeof this.props.userData === 'object' &&
      'isLoggedIn' in this.props.userData &&
      this.isUserLoggedin()
    ) {
      this.onWindowResize();
    }
    if (
      prevProps.stickyHeader !== this.props.stickyHeader &&
      !this.props.stickyHeader
    ) {
      this.addOverflowToNavLinks();
      this.onWindowResize();
    }
  }

  componentWillUnmount = () => {
    if (window) window.removeEventListener('resize', this.onWindowResize);
  };

  onWindowResize = () => {
    this.setStateWithProps(this.props);
    // this.checkGeoAndUpdateNav();
  };

  setStateWithProps = props => {
    this.l1Items = [];
    this.l2Items = [];
    this.setState(
      {
        l1Sections:
          props.navigationData && props.navigationData.l1
            ? props.navigationData.l1
            : null,
        l1cyclicSections: [],
        l2Sections:
          props.navigationData && props.navigationData.l2
            ? props.navigationData.l2
            : null,
        l2cyclicSections: [],
      },
      this.setCyclicItems,
    );
  };

  checkGeoAndUpdateNav = () => {
    const geoCountry = getGeoCountry();
    const {
      toiAssistNavEnabled,
      isPrime,
      toipLayout,
      pageType,
      userData,
      isWapView,
    } = this.props;
    if (
      geoCountry &&
      geoCountry === 'IN' &&
      toiAssistNavEnabled &&
      toiAssistNavEnabled === '1' &&
      ((userData &&
        typeof userData === 'object' &&
        'isLoggedIn' in userData &&
        this.isUserLoggedin()) ||
        isPrime) &&
      !toipLayout &&
      (!pageType || (pageType && pageType !== 'HomeUs')) &&
      !this.geoBasedAssistSet
    ) {
      if (!this.toiAssistViewFired) {
        setTimeout(() => {
          const bodystruct = {
            version: '04Jul2023',
            l_bot_shown: '',
            type: 'redirect',
          };
          analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
            slot_name: 'toi_globalheader',
            body: JSON.stringify(bodystruct),
          });
        }, 5000);
        this.toiAssistViewFired = true;
      }
      const { navigationData } = this.props;
      if (
        navigationData &&
        navigationData.l1 &&
        Array.isArray(navigationData.l1)
      ) {
        const index = navigationData.l1.findIndex(item => !item.selected);
        const timesAssistLink = {
          label: 'Chat with AI',
          link: `https://timesassist.com?refer_type=${
            isWapView ? 'mweb' : 'web'
          }&refer_template=${
            pageType === 'Home' ? 'homepage' : pageType.toLowerCase()
          }`,
          styles: ['newbadge'],
        };
        if (index === -1) {
          navigationData.l1.splice(0, 0, timesAssistLink);
        } else {
          navigationData.l1.splice(index, 0, timesAssistLink);
        }
        this.setStateWithProps({ navigationData });
      }
      this.geoBasedAssistSet = true;
    }
  };

  removeOverflowFromNavLinks = () => {
    if (
      this.l1navLinks &&
      this.l1navLinks instanceof HTMLElement &&
      this.l1navLinks.classList.contains('nav_links_overflow_hidden')
    ) {
      this.l1navLinks.classList.remove('nav_links_overflow_hidden');
    }
    if (
      this.l2navLinks &&
      this.l2navLinks instanceof HTMLElement &&
      this.l2navLinks.classList.contains('nav_links_overflow_hidden')
    ) {
      this.l2navLinks.classList.remove('nav_links_overflow_hidden');
    }
  };

  addOverflowToNavLinks = () => {
    if (
      this.l1navLinks &&
      this.l1navLinks instanceof HTMLElement &&
      !this.l1navLinks.classList.contains('nav_links_overflow_hidden')
    ) {
      this.l1navLinks.classList.add('nav_links_overflow_hidden');
    }
    if (
      this.l2navLinks &&
      this.l2navLinks instanceof HTMLElement &&
      !this.l2navLinks.classList.contains('nav_links_overflow_hidden')
    ) {
      this.l2navLinks.classList.add('nav_links_overflow_hidden');
    }
  };

  setCyclicItems = () => {
    const { hideCyclicNav } = this.props;
    const dotsWidth = hideCyclicNav ? 0 : 55;
    const l1TotalWidth =
      this.l1navContainer && this.l1Items.length
        ? this.l1navContainer.offsetWidth - (dotsWidth + 30)
        : 0;
    const l2TotalWidth =
      this.l2navContainer && this.l2Items.length
        ? this.l2navContainer.offsetWidth - (dotsWidth + 20)
        : 0;
    let currentWidth = 0;
    const l1Sections = [];
    const l1cyclicSections = [];
    const l2Sections = [];
    const l2cyclicSections = [];

    this.l1Items.forEach((item, index) => {
      currentWidth += item.offsetWidth;
      if (currentWidth > l1TotalWidth) {
        l1cyclicSections.push(this.state.l1Sections[index]);
      } else {
        l1Sections.push(this.state.l1Sections[index]);
      }
    });

    currentWidth = 0;
    this.l2Items.forEach((item, index) => {
      currentWidth += item.offsetWidth;
      if (currentWidth > l2TotalWidth) {
        l2cyclicSections.push(this.state.l2Sections[index]);
      } else {
        l2Sections.push(this.state.l2Sections[index]);
      }
    });

    if (l1cyclicSections.length || l2cyclicSections.length) {
      this.setState(
        {
          l1Sections,
          l1cyclicSections,
          l2Sections,
          l2cyclicSections,
        },
        () => {
          this.removeOverflowFromNavLinks();
        },
      );
    } else {
      this.removeOverflowFromNavLinks();
    }
  };

  getCyclicMenu = (cyclicSections, navLevel) => {
    const secData = [];
    const chunkset = 15;
    const colno = Math.ceil(cyclicSections.length / chunkset);
    const colstyleName = `col${colno}`;

    if (cyclicSections && cyclicSections.length) {
      cyclicSections.forEach(cyclicSec => {
        const gaLabel = `${Navigation.gaCategory}|L${navLevel}_more_menu|${
          cyclicSec.label
        }`;

        secData.push(
          <li
            className={`${s.list_item} ${s.cyclicItem}`}
            key={cyclicSec.label}
          >
            <Link
              to={cyclicSec.link}
              className={s.nav_link}
              // subText={cyclicSec?.subText}
              data-ga={gaLabel}
            >
              {cyclicSec.label}
            </Link>
            {navLevel === 1 && (
              <React.Fragment>
                <meta itemProp="name" content={cyclicSec.label} />
                <meta itemProp="url" content={cyclicSec.link} />
              </React.Fragment>
            )}
          </li>,
        );
      });
      return (
        <li
          className={`${s.nav_item} hello ${s.cyclicContainer}`}
          key="cyclicContainer"
        >
          <span className={s.dots}>
            <i />
          </span>
          <div className={`${s.dropdown} ${s.multi_list} ${s[colstyleName]}`}>
            <div className={`${s.list0}`}>
              <ul key="cyclicList">{secData}</ul>
            </div>
          </div>
        </li>
      );
    }
    return null;
  };

  navigationOnHover = (item, level, index) => {
    if (level !== 1 || !item || !(item.wu || item.subMenu)) {
      return;
    }

    const navHoverKey = `hover-${index}`;

    if (this.state.navHoverKey !== navHoverKey) {
      this.setState({ navHoverKey });
    }
  };

  removeNavigationHover = (level, index) => {
    if (level !== 1) {
      return;
    }

    const navHoverKey = `hover-${index}`;

    if (this.state.navHoverKey === navHoverKey) {
      this.setState({ navHoverKey: '' });
    }
  };

  hasAnySubmenuUrl = subMenu => {
    let hasWebUrl = false;
    let counter = 0;
    for (; counter < subMenu.length; counter += 1) {
      if (subMenu[counter].wu) {
        hasWebUrl = true;
        break;
      }
    }

    return hasWebUrl;
  };

  backButtonHandler = link => {
    window.location.href = link;
  };

  iterateOverObject = (
    sections,
    classname,
    navLevel,
    secHead,
    colorTheme,
    backButton,
  ) => {
    const secData = [];
    const { pageType, toipLayout } = this.props;
    if (sections && sections.length > 0) {
      const sectionLength = sections.length;
      sections.forEach((navSec, index) => {
        let _ga = '';
        if (pageType && pageType === 'Home') {
          _ga = `${Navigation.gaCategory}|Navbar${
            secHead ? `_${secHead}` : ''
          }_${navSec.label}|${navSec.link}`;
        } else if (secHead) {
          _ga = `${Navigation.gaCategory}|L1_child|${secHead}/${navSec.label}`;
        }
        let customClasses = '';
        let customClassesDynamic = '';

        if (navSec.styles && navSec.styles.length) {
          customClassesDynamic = getClassesFromArray(navSec.styles, s);
        }
        if (navLevel === 1 && navSec.selected) {
          customClasses = index === 0 ? s.root : s.level1;
        } else if (navLevel === 2 && navSec.selected) {
          customClasses = s.level2;
        } else if (navLevel === 1 && navSec.isTop === 'true') {
          customClasses = s.level1;
        }
        if (
          navLevel === 2 &&
          this.props.forSelectedL2Link &&
          this.props.forSelectedL2Link === navSec.link
        ) {
          customClasses = s.level2;
        }
        if (
          (navLevel === 1 || navLevel === 2) &&
          pageType &&
          pageType === 'Home'
        ) {
          _ga = `${Navigation.gaCategory}|Navbar_${navSec.label}|${
            navSec.link
          }`;
        } else if (
          (navLevel === 1 || navLevel === 2) &&
          pageType &&
          pageType === 'explainers'
        ) {
          _ga = `${Navigation.gaCategory}|click_navigation_${navSec.label}|${
            navSec.link
          }`;
        } else if (
          (navLevel === 1 || navLevel === 2) &&
          pageType &&
          toipLayout
        ) {
          if (getSeoName(navSec.label) === TIMES_SPECIAL_NOC_NAME) {
            customClassesDynamic = getClassesFromArray(['newbadge'], s);
          }
          const gaCat = 'TOI Plus';
          const gaaction = `TOIPlus_topTab_${navSec.label}_click`;
          const { userData } = this.props;
          const isLoggedIn =
            userData && userData.isLoggedIn ? userData.isLoggedIn : false;
          const prcValue =
            userData && userData.prcValue ? userData.prcValue : 0;
          const galabel = `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`;
          _ga = `${gaCat}|${gaaction}|${galabel}`;
        } else if (navLevel === 1 || navLevel === 2) {
          _ga = `${Navigation.gaCategory}|L${navLevel}_parent|${navSec.label}`;
        }
        if (
          typeof backButton === 'object' &&
          backButton.link &&
          navLevel === 2 &&
          index === 0 &&
          navSec.selected
        ) {
          secData.push(
            <li
              className={s.back}
              onClick={() => {
                this.backButtonHandler(backButton.link);
              }}
            />,
          );
        }
        if (navSec && navSec.label)
          secData.push(
            <li
              className={`${classname} ${customClassesDynamic} ${customClasses} ${
                navSec.selected && colorTheme ? s[colorTheme] : ''
              } ${navSec.theme ? navSec.theme : ''} ${
                navSec.label && navSec.label.toLowerCase() === 'pollution news'
                  ? s.active_red
                  : ''
              } ${
                getSeoName(navSec.label) === TIMES_SPECIAL_NOC_NAME
                  ? s.timesspecialnav
                  : ''
              }`}
              ref={el => {
                if (el && navLevel === 1) {
                  this.l1Items.push(el);
                } else if (el && navLevel === 2) {
                  this.l2Items.push(el);
                }
              }}
              key={navSec.label}
              onMouseOver={() => {
                this.navigationOnHover(navSec, navLevel, index);
              }}
              onMouseOut={() => {
                this.removeNavigationHover(navLevel, index);
              }}
            >
              <Link
                to={navSec.link}
                className={`${s.nav_link} ${
                  navLevel === 2 ? s.nav_link_l2 : ''
                } ${
                  `hover-${index}` === this.state.navHoverKey
                    ? s.activeNav
                    : null
                } ${s[navSec.linkNameClass]}`}
                data-ga={_ga}
                aria-label={navSec.label}
                onClick={() => {
                  if (
                    navSec &&
                    navSec.label &&
                    navSec.label === 'Chat with AI'
                  ) {
                    const bodystruct = {
                      version: '04Jul2023',
                      bot_click: '',
                      l_bot_shown: '',
                      type: 'redirect',
                    };
                    analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
                      slot_name: 'toi_globalheader',
                      body: JSON.stringify(bodystruct),
                    });
                  }
                  const gaData = {
                    event: 'user_click',
                    type: 'header',
                    category: `l${navLevel}`,
                    label: `${navSec.label}`,
                  };
                  if (navSec && navSec.label && navSec.label === 'TOI Games') {
                    gaData.user_grx_id = Cookie?.get('_grx') || '';
                  }
                  analyticsWrapper('ga4', gaData);
                }}
                target="_blank"
                // subText={navSec?.subText}
              >
                {/* support for banners on navigation */}
                {navSec.theme && navSec.theme === 'times_health_survey' ? (
                  <Image
                    src="https://static.toiimg.com/photo/72184087.cms"
                    lazyload
                    placeHolderSrc="https://static.toiimg.com/photo/72184087.cms"
                    offsetVertical={100}
                    alt={navSec.label}
                  />
                ) : (
                  navSec.label
                )}
              </Link>
              {navLevel === 1 ? (
                <React.Fragment>
                  <meta itemProp="name" content={navSec.label} />
                  <meta itemProp="url" content={navSec.link} />
                  {navSec.wu &&
                    this.state.isClientSide && (
                      <NavDropDown
                        item={navSec}
                        activeNavHoverKey={this.state.navHoverKey}
                        hoverKey={`hover-${index}`}
                        // postionRight={index + 1 > sectionLength / 2}
                        postionRight={
                          sectionLength > 4
                            ? index + 1 > sectionLength / 2
                            : false
                        }
                        // theme={
                        //   navSec.type === 'photo' || navSec.type === 'video'
                        //     ? navSec.theme
                        //     : ''
                        // }
                        colorTheme={colorTheme}
                      />
                    )}
                  {navSec.subMenu &&
                    navSec.subMenu.length > 0 &&
                    this.hasAnySubmenuUrl(navSec.subMenu) &&
                    this.state.isClientSide && (
                      <NavDropDownList
                        item={navSec}
                        activeNavHoverKey={this.state.navHoverKey}
                        hoverKey={`hover-${index}`}
                        // postionRight={index + 1 > sectionLength / 2}
                        postionRight={
                          sectionLength > 4
                            ? index + 1 > sectionLength / 2
                            : false
                        }
                        theme={navSec.theme}
                        colorTheme={colorTheme}
                        pageType={pageType}
                      />
                    )}
                  {/* {navSec.label &&
                    navSec.label.toLowerCase() === 'budget and you' && (
                      <Link
                        href="http://pubads.g.doubleclick.net/gampad/clk?id=5905684931&iu=/7176/TOI/TOI_Budget/TOI_Budget_CLK_Tracker_1"
                        className={s.budgetyou}
                        target="_blank"
                      >
                        <div>Sponsored By</div>
                        <div className={`${s.list0}`}>
                          <img
                            src="https://static.toiimg.com/photo/msid-89202527.cms"
                            alt="Hindware"
                          />
                        </div>
                      </Link>
                    )} */}
                </React.Fragment>
              ) : null}
              {navSec.subMenuList ? (
                <span className={s.dropdown_arrow} />
              ) : null}
              {navSec.subMenuList ? this.getNavChild(navSec.subMenuList) : null}
            </li>,
          );
      });
    }
    if (navLevel === 1) {
      return (
        <ul
          itemType="http://www.schema.org/SiteNavigationElement"
          itemScope="itemscope"
          key="levelOneList"
        >
          {secData}
          {/*  L1 Last Campiagn  */}
          {this.getCyclicMenu(this.state.l1cyclicSections, navLevel)}
        </ul>
      );
    } else if (navLevel === 2) {
      return (
        <ul key="levelTwoList">
          {secData}
          {this.getCyclicMenu(this.state.l2cyclicSections, navLevel)}
        </ul>
      );
    }
    return <ul key="navChildList">{secData}</ul>;
  };

  getNavChild = obj => {
    switch (obj.type) {
      case 'multiList': {
        const multiList = [];
        if (obj.data && obj.data.length > 0) {
          obj.data.forEach((sec, index) => {
            const indexSpecificClass = `list${index}`;
            multiList.push(
              <div
                className={`${s[indexSpecificClass]}`}
                //className={`${s.list} ${s[indexSpecificClass]}`}
                key={sec.label}
              >
                {sec.label && <h4 className={s.list_title}>{sec.label}</h4>}
                {this.iterateOverObject(
                  sec.data,
                  `${s.list_item}`,
                  undefined,
                  sec.label,
                )}
              </div>,
            );
          });
          return (
            <div className={`${s.dropdown} ${s.multi_list}`}>{multiList}</div>
          );
        }
        break;
      }
      case 'multiList2': {
        //multiList2 is without label
        const multiList = [];
        if (obj.data && obj.data.length > 0) {
          obj.data.forEach(sec => {
            multiList.push(
              <div className={`${s.list1}`} key={sec.label}>
                {this.iterateOverObject(
                  sec.data,
                  `${s.list_item}`,
                  undefined,
                  sec.label,
                )}
              </div>,
            );
          });
          return (
            <div className={`${s.dropdown} ${s.multi_list}`}>{multiList}</div>
          );
        }
        break;
      }
      default:
        return null;
    }
    return null;
  };

  @bindGa({})
  showHamburgIcon() {
    this.setState({
      showHamburg: true,
    });

    this.sendHamburgerGA(true);
  }

  showCloseIcon() {
    this.setState({
      showHamburg: false,
    });
    this.sendHamburgerGA(false);
  }

  sendHamburgerGA = isOpen => {
    sendGaThroughProps({
      data: {
        gaCategory: `${Navigation.gaCategory}`,
        gaAction: 'L1_hamburger_icon',
        gaLabel: `${isOpen ? 'Open' : 'Close'}`,
      },
    });
  };

  getAllSectionsData = (
    data,
    type = `
hamburger`,
  ) => {
    const allSecData = [];
    if (data && data.sections) {
      const allSections = data.sections;
      let colData = [];
      allSections.forEach(menucolumn => {
        menucolumn.forEach(sec => {
          let heading;
          const subSecsData = [];
          if (sec.link) {
            heading = (
              <h3 className={s.allcat_head}>
                <Link to={sec.link} data-ga={`${type}_menu|${sec.label}|`}>
                  {sec.label}
                </Link>
                {sec.brandlink && (
                  <Link
                    to={sec.brandlink}
                    data-ga={`${type}_menu|${sec.brandlabel}|`}
                    className={sec.brandclass}
                    target="_blank"
                  >
                    <img
                      src={`https://static.toiimg.com/photo/msid-${
                        sec?.brandimgid
                      }.cms`}
                      alt={`${sec.brandlabel}`}
                    />
                  </Link>
                )}
              </h3>
            );
          } else {
            heading = <h3 className={s.allcat_head}>{sec.label}</h3>;
          }
          if (sec.items && sec.items.length > 0) {
            const subSecs = sec.items;
            subSecs.forEach(subsec => {
              subSecsData.push(
                <li>
                  <Link
                    to={subsec.link}
                    data-ga={`${type}_menu|${subsec.label}|`}
                    key={subsec.label}
                    className={subsec.brandclass}
                  >
                    {subsec.label}
                  </Link>
                </li>,
              );
            });
          }
          colData.push(
            <div className={s.all_sec_cat}>
              {heading}
              <ul>{subSecsData}</ul>
            </div>,
          );
        });
        allSecData.push(<div className={s.menu_column}>{colData}</div>);
        colData = [];
      });
    }
    return <div className={s.allSections}>{allSecData}</div>;
  };

  getHomeNode = (homeNode = {}) => {
    const _headingType = homeNode.headingType || 'h2';
    const { showHomeOnlyWhenSticky, pageType } = this.props;
    const CustomTag = `${_headingType}`;
    if (
      typeof pageType !== 'undefined' &&
      (pageType === 'Home' || pageType === 'HomeUs' || pageType === 'Games')
    ) {
      return null;
    }
    return (
      <div
        itemType="https://schema.org/Organization"
        itemScope="itemscope"
        itemProp="publisher"
        className={`${s.logowrapper} ${classNames({
          [s.homeOnlySticky]: showHomeOnlyWhenSticky,
        })}`}
      >
        <CustomTag>
          <Link
            to={homeNode.link || '/'}
            className={s['toi-logo']}
            data-ga={`${Navigation.gaCategory}|L1_toi_logo|home`}
            title="News"
            alt="News"
          >
            TOI
          </Link>
        </CustomTag>
        <span
          itemType="https://schema.org/ImageObject"
          itemScope="itemscope"
          itemProp="logo"
        >
          <meta
            content="https://static.toiimg.com/photo/msid-58127550/toilogo.jpg"
            itemProp="url"
          />
          <meta content="600" itemProp="width" />
          <meta content="60" itemProp="height" />
        </span>

        <meta
          content={
            this.props.isReviewsPage ? 'Times Reviews ' : 'The Times of India'
          }
          itemProp="name"
        />
        <meta
          content={`https://${
            this.props.isReviewsPage ? 'reviews' : 'timesofindia'
          }.indiatimes.com`}
          itemProp="url"
        />
      </div>
    );
  };
  /**
   *  function to get GA category
   * @param {*} pageType
   * @param {*} stickyHeader
   */
  getGaCategory = (pageType, stickyHeader) => {
    if (pageType && pageType === 'Home') {
      return WEB_INDIA_HP_GA_CAT;
    } else if (pageType && pageType === 'coronavirus') {
      return `${CORONAVIRUS_GA_CATEGORY}_WEB`;
    } else if (pageType && pageType === 'explainers') {
      return EXPLAINERS_GA_CATEGORY;
    } else if (stickyHeader) {
      return 'sticky_nav_menu';
    }
    return 'nav_menu';
  };

  onClickOnSearchBtn = () => {
    this.setState({
      isSearchOpen: !this.state.isSearchOpen,
    });
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'header',
      category: 'search',
    });
  };

  render() {
    const {
      allMenu,
      navigationData,
      stickyHeader,
      colorTheme,
      hideCyclicNav,
      pageType,
      geolocation,
      showToiPlusEntryPoints,
      toipLayout,
      isPrimeUserLayout,
      hideTodaysEpaperButton = false,
    } = this.props;
    const hamburgIcon = !this.state.showHamburg
      ? `${s.hamburg_icon}`
      : `${s.close_icon}`;
    Navigation.gaCategory = this.getGaCategory(pageType, stickyHeader);
    const theme = colorTheme ? s[colorTheme] : s.rust;
    const isL1Exist = this.state.l1Sections && this.state.l1Sections.length;
    const isL2Exist = this.state.l2Sections && this.state.l2Sections.length;
    const IndiaGeo = !geolocation || geolocation === '1';
    if (isL1Exist) {
      return (
        <div
          className={`${s.navwrapper} ${theme} ${classNames({
            [s.l2Exist]: isL2Exist,
            [s.hideCyclicNav]: hideCyclicNav,
            [s.fixheader]: stickyHeader,
            [s.toiphp]: toipLayout,
            [s.primelayout]: isPrimeUserLayout,
            [s.search_open]: this.state.isSearchOpen,
          })}`}
        >
          <div className={`${s.navigation} ${'navigation'}`}>
            {navigationData.l1 && (
              <div
                className={`${s.l1section}
              ${
                typeof navigationData.leftNav !== 'undefined'
                  ? s.toiplusBtn
                  : ''
              }
                ${colorTheme === 'snowwhite' ? s.navV2 : ''}
              
                ${isPrimeUserLayout ? s.primelayout : ''}`}
              >
                <div
                  className={`contentwrapper rpos ${
                    isPrimeUserLayout ? s.contentwrapper : ''
                  }`}
                >
                  {navigationData.home && this.getHomeNode(navigationData.home)}
                  <div
                    className={`${s.l1navListWrapper} ${
                      pageType === 'ARTICLESHOW' || pageType === 'LIVEBLOG'
                        ? s.print_text
                        : ''
                    } ${isPrimeUserLayout ? s.prime_nav_pos : ''}`}
                    ref={el => {
                      if (el) {
                        this.l1navContainer = el;
                      }
                    }}
                  >
                    {navigationData && navigationData.leftNav instanceof Array
                      ? navigationData.leftNav.map(item => (
                          <Link
                            to={item.link}
                            className={`${s[item.css]} ${
                              !IndiaGeo ? s.other : ''
                            }`}
                            data-ga={
                              pageType === 'Home'
                                ? `${Navigation.gaCategory}|Navbar_${
                                    item.label
                                  }|${item.link}`
                                : ''
                            }
                          >
                            {item.label}
                          </Link>
                        ))
                      : null}
                    <nav
                      className={`${
                        s.nav_list
                      } nav_links_wrapper nav_links_overflow_hidden`}
                      ref={el => {
                        if (el) {
                          this.l1navContainer = el;
                          this.l1navLinks = el;
                        }
                      }}
                    >
                      {this.iterateOverObject(
                        this.state.l1Sections,
                        `${s.nav_item}`,
                        1,
                        undefined,
                        colorTheme,
                        navigationData.back,
                      )}
                    </nav>
                    {navigationData &&
                    navigationData.rightNav instanceof Array &&
                    showToiPlusEntryPoints
                      ? navigationData.rightNav.map(item => (
                          <Link
                            to={item.link}
                            className={`${s[item.css]} ${
                              !IndiaGeo ? s.other : ''
                            }`}
                            data-ga={
                              pageType === 'Home'
                                ? `${Navigation.gaCategory}|Navbar_${
                                    item.label
                                  }|${item.link}`
                                : ''
                            }
                            ga4Data={
                              item?.ga4Type && [
                                {
                                  event: 'user_click',
                                  type: `${item.ga4Type}`,
                                  category: `${item.ga4Category || ''}`,
                                  label: `${item.ga4Label || ''}`,
                                },
                              ]
                            }
                          >
                            {item.label}
                          </Link>
                        ))
                      : null}
                  </div>
                  {!(toipLayout || hideTodaysEpaperButton) && (
                    <>
                      {(pageType === 'ARTICLESHOW' ||
                        pageType === 'LIVEBLOG') && (
                        <div className={s.epaper_button_wrapper}>
                          <Link
                            type="button"
                            className={s.epaper_button}
                            to={TOI_EPAPER_URL_WEB}
                            ga4Data={[
                              {
                                event: 'user_click',
                                type: 'header',
                                category: 'read_epaper',
                              },
                            ]}
                          >
                            Today&apos;s ePaper
                          </Link>
                        </div>
                      )}
                      <Search
                        theme={colorTheme}
                        isWapView={this.props.isWapView}
                        sticky={stickyHeader}
                        highlightSearchedWordInResult
                        onClickOnSearchBtn={this.onClickOnSearchBtn}
                        isPrimeUserLayout={isPrimeUserLayout}
                      />

                      <div
                        className={`hamburg ${hamburgIcon}`}
                        onClick={e => {
                          if (this.state.showHamburg) {
                            this.showCloseIcon(e);
                          } else {
                            this.showHamburgIcon(e);
                          }
                          analyticsWrapper('ga4', {
                            event: 'user_click',
                            type: 'header',
                            category: 'hamburg',
                          });
                        }}
                      >
                        <span />
                      </div>
                      {this.state.showHamburg &&
                        this.getAllSectionsData(allMenu, 'hamburger')}
                    </>
                  )}
                </div>
              </div>
            )}
            {navigationData.l2 && (
              <>
                <div className={s.l2section}>
                  <div
                    className={`contentwrapper rpos  ${
                      isPrimeUserLayout ? s.contentwrapper : ''
                    }`}
                  >
                    <div
                      className={s.l2navListWrapper}
                      ref={el => {
                        if (el) {
                          this.l2navContainer = el;
                        }
                      }}
                    >
                      <nav
                        className={`${
                          s.nav_list
                        } nav_links_wrapper nav_links_overflow_hidden`}
                        ref={el => {
                          if (el) {
                            this.l2navLinks = el;
                          }
                        }}
                      >
                        {this.iterateOverObject(
                          this.state.l2Sections,
                          `${s.nav_item}`,
                          2,
                          undefined,
                          '',
                          navigationData.back,
                        )}
                      </nav>
                    </div>
                  </div>
                </div>
                {this.props.l2navigationChild && (
                  <div>{this.props.l2navigationChild}</div>
                )}
              </>
            )}
          </div>
        </div>
      );
    }
    return null;
  }
}

Navigation.propTypes = {
  navigationData: PropTypes.shape({
    home: PropTypes.shape({}),
    l1: PropTypes.arrayOf.isRequired,
    l2: PropTypes.arrayOf,
    colorTheme: PropTypes.string,
    back: PropTypes.shape({}),
    rightNav: PropTypes.arrayOf,
  }),
  allMenu: PropTypes.shape({}).isRequired,
  colorTheme: PropTypes.string,
  isWapView: PropTypes.bool.isRequired,
  stickyHeader: PropTypes.bool,
  l2navigationChild: PropTypes.shape({}),
  hideCyclicNav: PropTypes.bool,
  showHomeOnlyWhenSticky: PropTypes.bool.isRequired,
  pageType: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  toipLayout: PropTypes.bool,
  isPrimeUserLayout: PropTypes.bool,
  isReviewsPage: PropTypes.bool,
};

Navigation.defaultProps = {
  stickyHeader: false,
  colorTheme: '',
  navigationData: {
    home: null,
    l1: [],
    l2: [],
  },
  hideCyclicNav: false,
  l2navigationChild: null,
  pageType: '',
  showToiPlusEntryPoints: false,
  userData: undefined,
  toipLayout: false,
  isPrimeUserLayout: false,
  isReviewsPage: false,
};

const mapStateToProps = state => ({
  isReviewsPage: state.isTOIReviews,
});

export default connect(mapStateToProps)(Navigation);
